export default __webpack_public_path__ + "static/bg1-c60ff585e420328f5c689226f1da2f89.jpg";